import styled from "styled-components"

import { useLazyGetVendorOrderSensorsQuery, useLazyGetVendorSensorStatusesQuery } from "store/api/adminApi"

import { WidgetsRowWrapper } from "layouts/WidgetsLayout/WidgetsRowWrapper"
import { WidgetContractors } from "components/widgets/WidgetContractors"
import { WidgetInstaledDevices } from "components/widgets/WidgetInstaledDevices"
import { WidgetOrderedSensors } from "components/widgets/WidgetOrderedSensors"
import { WidgetPhysicalStatus } from "components/widgets/WidgetPhysicalStatus"
import { WidgetSensorStatuses } from "components/widgets/WidgetSensorStatuses"
import { WidgetSTAndMemberships } from "components/widgets/WidgetSTAndMemberships"
import { WidgetVendorAlerts } from "components/widgets/WidgetVendorAlerts"
import { WidgetVendorAlertStatuses } from "components/widgets/WidgetVendorAlertStatuses"
import { WidgetVendorOrderStatus } from "components/widgets/WidgetVendorOrderStatus"
import { WidgetWarehouseInformation } from "components/widgets/WidgetWarehouseInformation"

import CustomerTrends from "./components/CustomerTrendsWidget"
import InstallationTrends from "./components/InstallationTrendsWidget"
import ReordersWidget from "./components/ReordersWidget"

const WidgetsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px 16px;
  padding-bottom: 24px;
`

const StyledWidgetsRowWrapper = styled(WidgetsRowWrapper)`
  flex: 1;

  @media only screen and (max-width: 1200px) {
    flex: 1 0 100%;
  }
`

const TrendsSectionWrapper = styled.div`
  width: 100%;
  padding: 24px 18px;
  background: #f8fafc;
  border-radius: 40px;
`

const TrendsSectionTitle = styled.h2`
  font-size: 24px;
  font-weight: 500;
  line-height: 1;
  margin-bottom: 16px;
  padding-left: 16px;
`

const TrendsFirstRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px 16px;
`

const TrendsSecondRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`

const ReordersWrapper = styled.div`
  max-width: 795px;
  width: 100%;
  margin: 0 auto;
`

const WidgetsHalfRowWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 24px 16px;

  > div > div > div {
    flex: 1 0 100%;
  }
`

export const Dashboard = () => {
  return (
    <WidgetsWrapper>
      <WidgetsRowWrapper title="Devices">
        <WidgetPhysicalStatus />
        <WidgetInstaledDevices isVendor />
      </WidgetsRowWrapper>
      <TrendsSectionWrapper>
        <TrendsSectionTitle>Trends</TrendsSectionTitle>
        <TrendsFirstRow>
          <InstallationTrends />
          <CustomerTrends />
        </TrendsFirstRow>
        <TrendsSecondRow>
          <ReordersWrapper>
            <ReordersWidget />
          </ReordersWrapper>
        </TrendsSecondRow>
      </TrendsSectionWrapper>
      <WidgetsRowWrapper title="Sensors">
        <WidgetOrderedSensors useLazyQuery={useLazyGetVendorOrderSensorsQuery} />
        <WidgetSensorStatuses useLazyQuery={useLazyGetVendorSensorStatusesQuery} />
      </WidgetsRowWrapper>
      <WidgetsRowWrapper title="Orders">
        <WidgetWarehouseInformation />
        <WidgetVendorOrderStatus />
      </WidgetsRowWrapper>
      <WidgetsHalfRowWrapper>
        <StyledWidgetsRowWrapper title="Contractors/Integration">
          <WidgetContractors />
          <WidgetSTAndMemberships />
        </StyledWidgetsRowWrapper>
        <StyledWidgetsRowWrapper title="Alerts">
          <WidgetVendorAlerts />
          <WidgetVendorAlertStatuses />
        </StyledWidgetsRowWrapper>
      </WidgetsHalfRowWrapper>
    </WidgetsWrapper>
  )
}
